export default __webpack_public_path__ + "static/media/loading.628a9db1.svg";